import { AppConfig } from '../../app/app.config';

export const ALL_CHANNELS = [
  AppConfig.Shared.EventTracker.MOENGAGE,
  AppConfig.Shared.EventTracker.CLEVER_TAP,
  AppConfig.Shared.EventTracker.CURESKIN_METRICS,
  AppConfig.Shared.EventTracker.BRANCH,
  AppConfig.Shared.EventTracker.MIXPANEL,
  AppConfig.Shared.EventTracker.AMPLITUDE,
];

export const CHANNELS_EXCLUDING_MIXPANEL = [
  AppConfig.Shared.EventTracker.MOENGAGE,
  AppConfig.Shared.EventTracker.CLEVER_TAP,
  AppConfig.Shared.EventTracker.CURESKIN_METRICS,
  AppConfig.Shared.EventTracker.BRANCH,
  AppConfig.Shared.EventTracker.AMPLITUDE,
];

export const PRIMARY_CHANNELS = [
  AppConfig.Shared.EventTracker.MOENGAGE,
  AppConfig.Shared.EventTracker.CLEVER_TAP,
  AppConfig.Shared.EventTracker.CURESKIN_METRICS,
];

export const DEFAULT_EVENT_TRACKER_CHANNELS = [
  AppConfig.Shared.EventTracker.CLEVER_TAP,
  AppConfig.Shared.EventTracker.AMPLITUDE,
  AppConfig.Shared.EventTracker.CURESKIN_METRICS,
  AppConfig.Shared.EventTracker.MOENGAGE,
];

export const DEFAULT_CHANNELS_EXCLUDING_AMPLITUDE = DEFAULT_EVENT_TRACKER_CHANNELS
  .filter((channel: string): boolean => channel !== AppConfig.Shared.EventTracker.AMPLITUDE);

export const AMPLITUDE_EXCLUDED_EVENT_NAMES = [
  'cartClicked',
  'concernSelected',
];

export const AMPLITUDE_EXCLUDED_EVENTS: { [eventName: string]: { [payloadKey: string]: string[] } } = {
  openedPage: {
    pageName: [
      'RegimenPage',
      'LanguagePage',
      'CartPage',
      'CheckoutPage',
      'ReviewOrderPage',
      'OrderListReorderPage',
    ],
  },
  impression: {
    bannerName: [
      'top_navigation_paid',
      'top_navigation_unpaid',
      'order_status',
      'complete_your_profile',
      'diet_banner_new',
      'cross_sell_face',
      'regimen_kit_ready_FACE',
      'regimen_kit_ready_HAIR',
      'incomplete_chat_face',
      'incomplete_chat_hair',
      'last_levels',
      'more_for_you',
    ],
    name: [
      'explore_post_impression',
      'checkup_nudge_back_bottom_sheet',
      'consultation_quiz',
    ],
    banner_name: ['order_delivery_banner_new'],
  },
  click: {
    name: [
      'home-face-nav',
      'home-hair-nav',
      'home-HOME_FACE',
      'home-HOME_HAIR',
      'partial_order_cancellation_voice_note',
      'multi-select-submitted',
      'product-article-page-visit',
      'explore-feed-video-played',
      'explore_feed_image_click',
      'voice_input_sent',
    ],
  },
};

/**
 * Base names of analytics events that fire a `_HAIR` variant for HAIR regimens
 * and the base name for FACE / BODY. The `_HAIR` suffix is not listed here — it
 * is computed by `EventLoggerService.getEventNameForClass`.
 */
export enum FirebaseAndBranchEvent {
  BUY_NOW_CLICKED = 'BUY_NOW_CLICKED',
  REGIMEN_VIEWED = 'REGIMEN_VIEWED',
  PRODUCT_VIEWED = 'PRODUCT_VIEWED',
  REGIMEN_CLICKED = 'REGIMEN_CLICKED',
  PRODUCT_CLICKED = 'PRODUCT_CLICKED',
  REGIMEN_PRODUCT_VIDEO_PLAYED = 'REGIMEN_PRODUCT_VIDEO_PLAYED',
  REGIMEN_VIEW_UNPAID = 'REGIMEN_VIEW_UNPAID',
  REGIMEN_VIEW_SEE_INSTRUCTION = 'REGIMEN_VIEW_SEE_INSTRUCTION',
  REGIMEN_VIEW_READ_ABOUT_DOCTOR = 'REGIMEN_VIEW_READ_ABOUT_DOCTOR',
  REGIMEN_VIEW_READ_ABOUT_SERVICES = 'REGIMEN_VIEW_READ_ABOUT_SERVICES',
  REGIMEN_VIEW_READ_ABOUT_PRODUCTS = 'REGIMEN_VIEW_READ_ABOUT_PRODUCTS',
  REGIMEN_VIEW_REGIMEN_IMAGE_CLICK = 'REGIMEN_VIEW_REGIMEN_IMAGE_CLICK',
  REGIMEN_VIEW_PRODUCT_IMAGE_CLICK = 'REGIMEN_VIEW_PRODUCT_IMAGE_CLICK',
}

/** Api marketing events re-sent to iOS — see ./CLAUDE.md */
export enum FirebaseAndBranchIOSEvent {
  CS_HAIR = 'CSHair',
  HAIR_PURCHASE = 'HAIR_PURCHASE',
  HAIR_PURCHASE_W = 'HAIR_PURCHASE_W',
  INITIAL_ORDER_HAIR = 'InitialOrderHair',
  INITIAL_ORDER_HAIR_W = 'InitialOrderHair_W',
  INSTANT_CHECKUP_18_PLUS_HAIR = 'InstantCheckup18PlusHair',
  INSTANT_CHECKUP_HAIR_W = 'InstantCheckupHair_W',
  REGIMEN_ALLOCATED_18_PLUS_HAIR = 'RegimenAllocated18PlusHair',
  REGIMEN_ALLOCATED_HAIR = 'RegimenAllocatedHair',
  REGIMEN_ALLOCATED_HAIR_W = 'RegimenAllocatedHair_W',
  REGIMEN_ALLOCATED_W_1845 = 'RegimenAllocatedW1845',
  REGIMEN_ALLOCATED_W_1845_HAIR = 'RegimenAllocatedW1845Hair',
}
